import React from 'react';

/**
 * HomeKpiStrip — compact dark KPI tiles for the Mission Control
 * Overview header (Overall Health · Data Confidence · At Risk). Each
 * item may carry a `delta` ({ dir:'up'|'down'|'flat', text }) rendered
 * as a small ▲/▼ badge so the range change reads instantly.
 */
export default function HomeKpiStrip({ items }) {
  return (
    <div className="grid grid-cols-3 gap-3" data-testid="home-kpi-strip">
      {items.map((k) => (
        <div
          key={k.label}
          className="rounded-xl border border-[#1f2a44] bg-[#111827] px-4 py-2.5 min-w-[104px]"
          data-testid={`home-kpi-${k.label.toLowerCase().replace(/ /g, '-')}`}
        >
          <div className="text-[10px] uppercase tracking-wider text-slate-500">{k.label}</div>
          <div className="flex items-baseline gap-1.5">
            <span className={`text-xl font-heading font-bold ${k.tone}`}>{k.value}</span>
            {k.delta && (
              <span
                className={`text-[10px] font-bold ${k.delta.dir === 'up' ? 'text-emerald-400' : k.delta.dir === 'down' ? 'text-rose-400' : 'text-slate-500'}`}
                data-testid={`home-kpi-${k.label.toLowerCase().replace(/ /g, '-')}-delta`}
                title="vs previous window"
              >
                {k.delta.dir === 'up' ? '▲' : k.delta.dir === 'down' ? '▼' : '▬'} {k.delta.text}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
